import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export function useDispute(disputeId) {
  return useQuery({
    queryKey: ['admin', 'dispute', disputeId],
    queryFn: async () => {
      if (!disputeId) return null;
      const token = localStorage.getItem('token');
      const { data } = await axios.get(
        `${API_BASE}/api/disputes/${disputeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    },
    enabled: !!disputeId,
    staleTime: 5 * 60 * 1000,
  });
}
